"use client";

import { syncCamFavorites } from "@/lib/cam-favorites";
import { useEffect } from "react";
import { startActivity } from "@/lib/activity";
import { startCoinsBadge } from "@/lib/coins-badge";
import { syncWithServer } from "@/lib/library";
import { syncWatching } from "@/lib/watching";

/** Mounted once in the site layout; links local lists to the signed-in account, counts time for Rankings and watches the daily coins. */
export function LibrarySync() {
  useEffect(() => {
    const stops: (() => void)[] = [];
    let unmounted = false;
    void syncWithServer()
      .then((signedIn) => {
        if (signedIn && !unmounted) {
          stops.push(startActivity(), startCoinsBadge());
          void syncCamFavorites().catch(() => {});
        }
      })
      .catch(() => {});
    void syncWatching().catch(() => {});
    return () => {
      unmounted = true;
      stops.forEach((stop) => stop());
    };
  }, []);
  return null;
}
